import React from 'react';
import { Dimensions, Platform, Pressable, View } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import {
  LightThemeColors,
  withTheme,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import ContactList from '../../../CommonUI/ContactList/ContactList';
import CustomTabs, { CustomTab } from '../../../CommonUI/CustomTabs';
import AddPaymentCard from '../../Containers/AddPaymentCard';
import { CUSTOM_AMOUNT_VALIDATION_STATUS } from '../../Utils/customAmountValidationStatus';
import { TOPUP_TAB_TYPES } from '../../Utils/topUpTabTypes';
import CustomAmount from '../CustomAmount/index';
import OfferGift from '../OfferGift/OfferGift';
import PaymentCenterView from '../PaymentCenterView';
import PaymentValues from '../PaymentValues';
import QRScannerHandler from '../QRScannerHandler';
import SelectedRecipient from '../SelectedRecipient/SelectedRecipient';
import SetupAutoBill from '../SetupAutoBill';
import SetupAutoTopUp from '../SetupAutoTopUp';
import VoucherTopUp from '../VoucherTopUp/VoucherTopUp';

import styles from './PaymentBody.Styles';

const PaymentBody = ({
  title,
  titlePlaceHolders,
  subTitle,
  subTitlePlaceHolders,
  mainTitle,
  mainTitlePlaceHolders,
  sourceImage,
  singleValue,
  value,
  wheelSelector,
  wheelValues,
  offerValues,
  onSelectWheelValue,
  defaultWheelValue,
  isPaymentRequest,
  isBillingPayment,
  titleGift,
  isTick,
  isPaymentFailed,
  upgradingPayment,
  isReward,
  giftIcon,
  wheelSelectorGiftIconAccessibilityLabel,
  wheelSelectorValueAccessibilityLabel,
  wheelSelectorCurrencyAccessibilityLabel,
  lottieID,
  mainTitleID,
  titleID,
  subTitleID,
  theme,
  lottietype,
  description,
  descriptionID,
  descriptionPlaceHolders,
  cardNumberLabel,
  nameOnCardLabel,
  expirationDateLabel,
  expirationDateFormatLabel,
  cvvNumberLabel,
  cardNameLabel,
  saveCardText,
  secureText,
  primaryButtonText,
  isSecureIcon,
  isSecureContainerBottomBorder,
  onPressSaveCard,
  hiddenFields,
  cardData,
  validations,
  saveForLaterIntialValue,
  shouldShowTempCardName,
  isAddingPaymentCard,
  isAutoBillSetup,
  isAutoTopUpSetup,
  autoTopUpData,
  onSelectBillDay,
  onSelectAutoTopUpData,
  currency,
  occurrenceSelectionTitle,
  occurrenceSelectionOptions,
  dateFilterBarTitle,
  dateFilterBarDescription,
  dateFilterBarSelectedDay,
  dateFilterBarDaysCount,
  isLoadingError,
  onTryAgainPress,
  isTopUpSomeOne,
  handleOnPressRecipient,
  recentContacts,
  accounts,
  onPhoneChanged,
  phoneNumberValidation,
  isValidPhoneNumber,
  setIsValidTopupNumber,
  onContactListIconPress,
  isContactList,
  setPhoneNo,
  userType,
  hideSaveCardForLater,
  selectedValue,
  onAddOffer,
  customTickLottie,
  selectedTab,
  onSelectTabChange,
  isCustomAmount,
  withCustomTabAmount,
  onChangeCustomAmount,
  customAmount,
  customAmountValidation,
  customAmountMaximum,
  isCurrencyFirst,
  isVoucherTopUp,
  shouldScanVoucherCode,
  setVoucherTopupNumber,
  voucherTopupNumber,
  onCameraPressed,
  onQRRead,
  onCodeChanged,
  maxLength,
  iconName,
  tintColor,
  textColor,
  helperTextColor,
  labelTextStyle,
  keyboardType,
  containerStyle,
  textInputContainerStyle,
  regexForInput,
  setIsValidVoucherTopupNumber,
  voucherBtnContainerStyle,
  selectionColor,
  baseColor,
  isVoucherTopUpContainer,
  qrCodeScannerProps,
  subtitleStyle,
  isValidTopupNumber,
  goBackView,
  isBalanceTopUp,
  isCenter,
  _toggleModal,
  ...props
}) => {
  const images = getThemeImages(theme.name);
  const titleWithGift = `${ContentManager.translate(mainTitle, mainTitlePlaceHolders)}`.replace(/\s+/g, ' ').trim()

  const renderBodyInsideBody = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      if (selectedTab === 'CUSTOM_AMOUNT_TOPUP') {
        return (
          <View style={styles.topUpSomeOneContainer}>
            <SelectedRecipient
              handleOnPressRecipient={handleOnPressRecipient}
              accounts={accounts}
              onPhoneChanged={onPhoneChanged}
              phoneNumberValidation={phoneNumberValidation}
              isValidPhoneNumber={isValidPhoneNumber}
              setIsValidTopupNumber={setIsValidTopupNumber}
              onContactListPress={onContactListIconPress}
              setPhoneNo={setPhoneNo}
              userType={userType}
            />
            <CustomTabs selectedTab={selectedTab} onPress={onSelectTabChange} isValidTopupNumber={isValidTopupNumber} >
              <CustomTab value={TOPUP_TAB_TYPES.DEFAULT_TOPUP}>
                {'custom_auto_top_up_first_tab'}
              </CustomTab>
              <CustomTab value={TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP}>
                {'custom_auto_top_up_second_tab'}
              </CustomTab>
            </CustomTabs>
            <CustomAmount
              currency={currency}
              onChangeCustomAmount={onChangeCustomAmount}
              customAmount={customAmount}
              customAmountValidation={customAmountValidation}
              customAmountMaximum={customAmountMaximum}
            />
          </View>
        )
      }
      else {
        return (
          <View style={styles.topUpSomeOneContainer}>
            <SelectedRecipient
              handleOnPressRecipient={handleOnPressRecipient}
              accounts={accounts}
              onPhoneChanged={onPhoneChanged}
              phoneNumberValidation={phoneNumberValidation}
              isValidPhoneNumber={isValidPhoneNumber}
              setIsValidTopupNumber={setIsValidTopupNumber}
              onContactListPress={onContactListIconPress}
              setPhoneNo={setPhoneNo}
              userType={userType}
            />
            <CustomTabs selectedTab={selectedTab} onPress={onSelectTabChange} isValidTopupNumber={isValidTopupNumber}>
              <CustomTab value={TOPUP_TAB_TYPES.DEFAULT_TOPUP} >
                {'custom_auto_top_up_first_tab'}
              </CustomTab>
              <CustomTab value={TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP} >
                {'custom_auto_top_up_second_tab'}
              </CustomTab>
            </CustomTabs>
            <PaymentValues
              singleValue={singleValue}
              value={selectedValue}
              wheelValues={wheelValues}
              offerValues={offerValues}
              currency={currency}
              onSelectWheelValue={onSelectWheelValue}
              defaultWheelValue={defaultWheelValue}
              isBillingPayment={isBillingPayment}
              giftIcon={giftIcon || images.ic_rewards}
              wheelSelectorCurrencyAccessibilityLabel={
                wheelSelectorCurrencyAccessibilityLabel
              }
              wheelSelectorGiftIconAccessibilityLabel={
                wheelSelectorGiftIconAccessibilityLabel
              }
              wheelSelectorValueAccessibilityLabel={
                wheelSelectorValueAccessibilityLabel
              }
              isValidTopupNumber={isValidTopupNumber}
            />
          </View>
        )
      }
    }
    else {
      return (
        <View style={styles.topUpSomeOneContainer}>
          {withCustomTabAmount && (
            <CustomTabs selectedTab={selectedTab} onPress={onSelectTabChange}>
              <CustomTab value={TOPUP_TAB_TYPES.DEFAULT_TOPUP}>
                {'custom_auto_top_up_first_tab'}
              </CustomTab>
              <CustomTab value={TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP}>
                {'custom_auto_top_up_second_tab'}
              </CustomTab>
            </CustomTabs>
          )}
          <SelectedRecipient
            handleOnPressRecipient={handleOnPressRecipient}
            accounts={accounts}
            onPhoneChanged={onPhoneChanged}
            phoneNumberValidation={phoneNumberValidation}
            isValidPhoneNumber={isValidPhoneNumber}
            setIsValidTopupNumber={setIsValidTopupNumber}
            onContactListPress={onContactListIconPress}
            setPhoneNo={setPhoneNo}
            userType={userType}
          />
        </View>
      )
    }
  }

  const renderBody = () => {
    if (isBalanceTopUp) {
      return (
        <View style={styles.topUpSomeOneContainer}>
          <CustomTabs selectedTab={selectedTab} onPress={onSelectTabChange} isValidTopupNumber={isValidTopupNumber}>
            <CustomTab value={TOPUP_TAB_TYPES.DEFAULT_TOPUP}>
              {'custom_auto_top_up_first_tab'}
            </CustomTab>
            <CustomTab value={TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP}>
              {'custom_auto_top_up_second_tab'}
            </CustomTab>
          </CustomTabs>
          {selectedTab === 'CUSTOM_AMOUNT_TOPUP' ?
            <CustomAmount
              currency={currency}
              onChangeCustomAmount={onChangeCustomAmount}
              customAmount={customAmount}
              customAmountValidation={customAmountValidation}
              customAmountMaximum={customAmountMaximum}
              isValidTopupNumber={isValidTopupNumber}
            />
            :
            <PaymentValues
              singleValue={singleValue}
              value={selectedValue}
              wheelValues={wheelValues}
              offerValues={offerValues}
              currency={currency}
              onSelectWheelValue={onSelectWheelValue}
              defaultWheelValue={defaultWheelValue}
              isBillingPayment={isBillingPayment}
              giftIcon={giftIcon || images.ic_rewards}
              wheelSelectorCurrencyAccessibilityLabel={
                wheelSelectorCurrencyAccessibilityLabel
              }
              wheelSelectorGiftIconAccessibilityLabel={
                wheelSelectorGiftIconAccessibilityLabel
              }
              wheelSelectorValueAccessibilityLabel={
                wheelSelectorValueAccessibilityLabel
              }
              isValidTopupNumber={isValidTopupNumber}
            />}
        </View>)
    }
    if (isCustomAmount) {
      return (
        <CustomAmount
          currency={currency}
          onChangeCustomAmount={onChangeCustomAmount}
          customAmount={customAmount}
          customAmountValidation={customAmountValidation}
          customAmountMaximum={customAmountMaximum}
        />
      )
    }
    if (isTopUpSomeOne) {
      return (renderBodyInsideBody())
    }
    if (isContactList) {
      return (
        <View style={styles.contactListContainer}>
          <ContactList
            onPressContact={handleOnPressRecipient}
            recentContacts={recentContacts}
          />
        </View>
      )
    }
    if (isAutoBillSetup) {
      return (
        <View style={styles.setupAutobillContainer}>
          <SetupAutoBill
            title={dateFilterBarTitle}
            description={dateFilterBarDescription}
            onItemSelect={onSelectBillDay}
            selectedIndex={dateFilterBarSelectedDay - 1}
            daysCount={dateFilterBarDaysCount}
          />
        </View>
      )
    }
    if (isAutoTopUpSetup) {
      return (
        <View style={styles.setupAutoTopUpContainer}>
          <SetupAutoTopUp
            title={occurrenceSelectionTitle}
            occurrenceOptions={occurrenceSelectionOptions}
            setAutoTopUpData={onSelectAutoTopUpData}
            selectedData={autoTopUpData}
            currency={currency}
          />
        </View>
      )
    }
    if (isAddingPaymentCard) {
      return (
        <AddPaymentCard
          cardNumberLabel={cardNumberLabel}
          nameOnCardLabel={nameOnCardLabel}
          expirationDateLabel={expirationDateLabel}
          expirationDateFormatLabel={expirationDateFormatLabel}
          cvvNumberLabel={cvvNumberLabel}
          cardNameLabel={cardNameLabel}
          saveCardText={saveCardText}
          secureText={secureText}
          primaryButtonText={primaryButtonText}
          inputContainerStyle={styles.inputContainer}
          halfSizeContainerStyle={styles.halfSizeContainer}
          secureTextStyle={styles.secureText(theme)}
          isSecureIcon={isSecureIcon}
          isSecureContainerBottomBorder={isSecureContainerBottomBorder}
          onPressSaveCard={onPressSaveCard}
          hiddenFields={hiddenFields}
          cardData={cardData}
          validations={validations}
          saveForLaterIntialValue={saveForLaterIntialValue}
          shouldShowTempCardName={shouldShowTempCardName}
          hideSaveCardForLater={hideSaveCardForLater}
          goBackView={goBackView}
          isCenter={isCenter}
        />
      )
    } else if (wheelSelector || singleValue) {
      return (
        <PaymentValues
          singleValue={singleValue}
          value={value}
          wheelValues={wheelValues}
          offerValues={offerValues}
          currency={currency}
          onSelectWheelValue={onSelectWheelValue}
          defaultWheelValue={defaultWheelValue}
          isBillingPayment={isBillingPayment}
          giftIcon={giftIcon || images.ic_rewards}
          wheelSelectorCurrencyAccessibilityLabel={
            wheelSelectorCurrencyAccessibilityLabel
          }
          wheelSelectorGiftIconAccessibilityLabel={
            wheelSelectorGiftIconAccessibilityLabel
          }
          wheelSelectorValueAccessibilityLabel={
            wheelSelectorValueAccessibilityLabel
          }
        />
      )
    } else if (isReward) {
      return (
        <OfferGift
          onAddOffer={onAddOffer}
          selectedValue={selectedValue}
          offerValues={offerValues}
          subTitleID={subTitleID}
          lottieID={lottieID}
          titleID={titleID}
        />
      )
    } else {
      return (
        <PaymentCenterView
          title={title}
          titlePlaceHolders={titlePlaceHolders}
          subTitle={subTitle}
          subTitlePlaceHolders={subTitlePlaceHolders}
          sourceImage={sourceImage}
          isPaymentRequest={isPaymentRequest}
          isTick={isTick}
          isPaymentFailed={isPaymentFailed}
          isReward={isReward}
          subTitleID={subTitleID}
          lottieID={lottieID}
          titleID={titleID}
          lottietype={lottietype}
          tryAgainIcon={images.ic_RefreshRed}
          isLoadingError={isLoadingError}
          onTryAgainPress={onTryAgainPress}
          customTickLottie={customTickLottie}
        />
      )
    }
  }

  // const renderBody = () => {
  //   if (shouldScanVoucherCode) {
  //     return (
  //       <QRScannerHandler
  //         onQRRead={onQRRead}
  //         qrCodeScannerProps={qrCodeScannerProps}
  //         subtitleStyle={subtitleStyle}
  //       />
  //     );
  //   } else if (isVoucherTopUp) {
  //     return (
  //       <>
  //         <VFText i18nKey={'de_voucher_top_up_subtitle'} style={styles.title(theme)} />
  //         <VoucherTopUp
  //           setIsValidVoucherTopupNumber={setIsValidVoucherTopupNumber}
  //           onCodeChanged={onCodeChanged}
  //           maxLength={maxLength}
  //           iconName={iconName}
  //           theme={theme}
  //           onCameraPressed={onCameraPressed}
  //           tintColor={tintColor}
  //           textColor={textColor}
  //           baseColor={baseColor}
  //           selectionColor={selectionColor}
  //           helperTextColor={helperTextColor}
  //           labelTextStyle={labelTextStyle}
  //           keyboardType={keyboardType}
  //           containerStyle={containerStyle}
  //           textInputContainerStyle={textInputContainerStyle}
  //           regexForInput={regexForInput}
  //           setVoucherTopupNumber={setVoucherTopupNumber}
  //           voucherTopupNumber={voucherTopupNumber}
  //         />
  //       </>
  //     );
  //   }

  //   if (isCustomAmount) {
  //     return (
  //       <CustomAmount
  //         currency={currency}
  //         onChangeCustomAmount={onChangeCustomAmount}
  //         customAmount={customAmount}
  //         customAmountValidation={customAmountValidation}
  //         customAmountMaximum={customAmountMaximum}
  //       />
  //     );
  //   }
  //   if (isTopUpSomeOne) {
  //     return (
  //       <View style={styles.topUpSomeOneContainer}>
  //         <SelectedRecipient
  //           handleOnPressRecipient={handleOnPressRecipient}
  //           accounts={accounts}
  //           onPhoneChanged={onPhoneChanged}
  //           phoneNumberValidation={phoneNumberValidation}
  //           isValidPhoneNumber={isValidPhoneNumber}
  //           setIsValidTopupNumber={setIsValidTopupNumber}
  //           onContactListPress={onContactListIconPress}
  //           setPhoneNo={setPhoneNo}
  //           userType={userType}
  //         />
  //       </View>
  //     );
  //   }
  //   if (isContactList) {
  //     return (
  //       <View style={styles.contactListContainer}>
  //         <ContactList onPressContact={handleOnPressRecipient} recentContacts={recentContacts} />
  //       </View>
  //     );
  //   }
  //   if (isAutoBillSetup) {
  //     return (
  //       <View style={styles.setupAutobillContainer}>
  //         <SetupAutoBill
  //           title={dateFilterBarTitle}
  //           description={dateFilterBarDescription}
  //           onItemSelect={onSelectBillDay}
  //           selectedIndex={dateFilterBarSelectedDay - 1}
  //           daysCount={dateFilterBarDaysCount}
  //         />
  //       </View>
  //     );
  //   }
  //   if (isAutoTopUpSetup) {
  //     return (
  //       <View style={styles.setupAutoTopUpContainer}>
  //         <SetupAutoTopUp
  //           title={occurrenceSelectionTitle}
  //           occurrenceOptions={occurrenceSelectionOptions}
  //           setAutoTopUpData={onSelectAutoTopUpData}
  //           selectedData={autoTopUpData}
  //           currency={currency}
  //         />
  //       </View>
  //     );
  //   }
  //   if (isAddingPaymentCard) {
  //     return (
  //       <AddPaymentCard
  //         cardNumberLabel={cardNumberLabel}
  //         nameOnCardLabel={nameOnCardLabel}
  //         expirationDateLabel={expirationDateLabel}
  //         expirationDateFormatLabel={expirationDateFormatLabel}
  //         cvvNumberLabel={cvvNumberLabel}
  //         cardNameLabel={cardNameLabel}
  //         saveCardText={saveCardText}
  //         secureText={secureText}
  //         primaryButtonText={primaryButtonText}
  //         inputContainerStyle={styles.inputContainer}
  //         halfSizeContainerStyle={styles.halfSizeContainer}
  //         secureTextStyle={styles.secureText(theme)}
  //         isSecureIcon={isSecureIcon}
  //         isSecureContainerBottomBorder={isSecureContainerBottomBorder}
  //         onPressSaveCard={onPressSaveCard}
  //         hiddenFields={hiddenFields}
  //         cardData={cardData}
  //         validations={validations}
  //         saveForLaterIntialValue={saveForLaterIntialValue}
  //         shouldShowTempCardName={shouldShowTempCardName}
  //         hideSaveCardForLater={hideSaveCardForLater}
  //       />
  //     );
  //   } else if (wheelSelector || singleValue) {
  //     return (
  //       <PaymentValues
  //         singleValue={singleValue}
  //         value={value}
  //         wheelValues={wheelValues}
  //         offerValues={offerValues}
  //         currency={currency}
  //         isCurrencyFirst={isCurrencyFirst}
  //         onSelectWheelValue={onSelectWheelValue}
  //         defaultWheelValue={defaultWheelValue}
  //         isBillingPayment={isBillingPayment}
  //         giftIcon={giftIcon || images.ic_rewards}
  //         wheelSelectorCurrencyAccessibilityLabel={wheelSelectorCurrencyAccessibilityLabel}
  //         wheelSelectorGiftIconAccessibilityLabel={wheelSelectorGiftIconAccessibilityLabel}
  //         wheelSelectorValueAccessibilityLabel={wheelSelectorValueAccessibilityLabel}
  //       />
  //     );
  //   } else if (isReward) {
  //     return (
  //       <OfferGift
  //         onAddOffer={onAddOffer}
  //         selectedValue={selectedValue}
  //         offerValues={offerValues}
  //         subTitleID={subTitleID}
  //         lottieID={lottieID}
  //         titleID={titleID}
  //       />
  //     );
  //   } else {
  //     return (
  //       <PaymentCenterView
  //         title={title}
  //         titlePlaceHolders={titlePlaceHolders}
  //         subTitle={subTitle}
  //         subTitlePlaceHolders={subTitlePlaceHolders}
  //         sourceImage={sourceImage}
  //         isPaymentRequest={isPaymentRequest}
  //         isTick={isTick}
  //         isPaymentFailed={isPaymentFailed}
  //         isReward={isReward}
  //         subTitleID={subTitleID}
  //         lottieID={lottieID}
  //         titleID={titleID}
  //         lottietype={lottietype}
  //         tryAgainIcon={images.ic_RefreshRed}
  //         isLoadingError={isLoadingError}
  //         onTryAgainPress={onTryAgainPress}
  //         customTickLottie={customTickLottie}
  //         isVoucherTopUpContainer={isVoucherTopUpContainer}
  //       />
  //     );
  //   }
  // };

  return (
    <View style={[styles.contentPadding, singleValue ? { marginHorizontal: 0 } : {}]}>
      {mainTitle && (
        <View style={[styles.headerContainer, singleValue ? {
          flexDirection: 'row',
          alignItems: 'flex-start',
          marginTop: Platform.OS === 'ios' ? 17.7 : 0,
          justifyContent: 'flex-start'
        } : {},
        isCenter && { marginTop: 0 }
        ]}>
          {isCenter && isAddingPaymentCard && (
            <Pressable
              style={{ marginRight: 8 }}
              onPress={goBackView}
            >
              <Icon
                name={images.ic_arrow_left}
                type="image"
                style={styles.headerIcon}
              />
            </Pressable>
          )}
          {titleGift && (
            <Icon name={giftIcon || images.ic_rewards} type="image" style={styles.headerIcon} />
          )}
          <VFText
            style={[styles.mainTitleStyle(theme), isCenter && { marginBottom: 0 }]}
            i18nKey={titleGift ? mainTitle : titleWithGift}
            placeHolders={mainTitlePlaceHolders}
            testID={mainTitleID}
          />
          {isCenter && (
            <View style={{ flex: 1, justifyContent: 'flex-end' }}>
              <Pressable onPress={_toggleModal}>
                <Icon
                  name={images.ic_close}
                  type="image"
                  style={[styles.headerIcon, { tintColor: theme.colors.textColor, alignSelf: 'flex-end' }]}
                />
              </Pressable>
            </View>
          )}
        </View>
      )}
      {description && (
        <VFText
          style={styles.description(theme)}
          i18nKey={description}
          testID={descriptionID}
          placeHolders={descriptionPlaceHolders}
        />
      )}

      {withCustomTabAmount && (Platform.OS !== 'web' || Dimensions.get('window').width < 700) &&
        <CustomTabs selectedTab={selectedTab} onPress={onSelectTabChange}>
          <CustomTab value={TOPUP_TAB_TYPES.DEFAULT_TOPUP}>
            {'custom_auto_top_up_first_tab'}
          </CustomTab>
          <CustomTab value={TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP}>
            {'custom_auto_top_up_second_tab'}
          </CustomTab>
        </CustomTabs>
      }

      {renderBody()}
    </View>
  );
};

PaymentBody.defaultProps = {
  titleGift: false,
  isReward: false,
  theme: LightThemeColors,
};

PaymentBody.propTypes = {
  title: PropTypes.string,
  titlePlaceHolders: PropTypes.arrayOf(PropTypes.string),
  subTitle: PropTypes.string,
  subTitlePlaceHolders: PropTypes.arrayOf(PropTypes.any),
  sourceImage: PropTypes.object,
  wheelSelector: PropTypes.bool,
  wheelValues: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  offerValues: PropTypes.shape({
    giftUnit: PropTypes.string,
    giftValue: PropTypes.number,
    giftNormalPrice: PropTypes.number,
    giftOfferPrice: PropTypes.number,
    currency: PropTypes.string,
  }),
  onSelectWheelValue: PropTypes.func,
  defaultWheelValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  isPaymentRequest: PropTypes.bool,
  isBillingPayment: PropTypes.bool,
  upgradingPayment: PropTypes.bool,
  isReward: PropTypes.bool,
  isTick: PropTypes.bool,
  isPaymentFailed: PropTypes.bool,
  wheelSelectorCurrencyAccessibilityLabel: PropTypes.string,
  wheelSelectorGiftIconAccessibilityLabel: PropTypes.string,
  wheelSelectorValueAccessibilityLabel: PropTypes.string,
  lottieID: PropTypes.string,
  mainTitleID: PropTypes.string,
  titleID: PropTypes.string,
  subTitleID: PropTypes.string,
  singleValue: PropTypes.bool,
  value: PropTypes.number,
  mainTitle: PropTypes.string,
  mainTitlePlaceHolders: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
  giftValue: PropTypes.string,
  currency: PropTypes.string,
  giftIcon: PropTypes.string,
  titleGift: PropTypes.bool,
  lottietype: PropTypes.string,
  description: PropTypes.string,
  descriptionID: PropTypes.string,
  descriptionPlaceHolders: PropTypes.arrayOf(PropTypes.string),
  cardNumberLabel: PropTypes.string,
  nameOnCardLabel: PropTypes.string,
  expirationDateLabel: PropTypes.string,
  expirationDateFormatLabel: PropTypes.string,
  cvvNumberLabel: PropTypes.string,
  cardNameLabel: PropTypes.string,
  saveCardText: PropTypes.string,
  secureText: PropTypes.string,
  primaryButtonText: PropTypes.string,
  isSecureIcon: PropTypes.bool,
  isSecureContainerBottomBorder: PropTypes.bool,
  onPressSaveCard: PropTypes.func,
  hiddenFields: PropTypes.oneOf(['nameOnCard', 'cardName']),
  cardData: PropTypes.object,
  validations: PropTypes.shape({
    cardName: PropTypes.func,
    nameOnCard: PropTypes.func,
    expirationData: PropTypes.func,
    ccvNo: PropTypes.func,
    cardNo: PropTypes.func,
  }),
  saveForLaterIntialValue: PropTypes.bool,
  shouldShowTempCardName: PropTypes.bool,
  isAddingPaymentCard: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isAutoBillSetup: PropTypes.bool,
  isAutoTopUpSetup: PropTypes.bool,
  autoTopUpData: PropTypes.shape({
    occurrence: PropTypes.string,
    selectedIndex: PropTypes.number,
    selectedValue: PropTypes.string,
  }),
  onSelectBillDay: PropTypes.func,
  onSelectAutoTopUpData: PropTypes.func,
  dateFilterBarTitle: PropTypes.string,
  dateFilterBarDescription: PropTypes.string,
  dateFilterBarSelectedDay: PropTypes.number,
  dateFilterBarDaysCount: PropTypes.number,
  occurrenceSelectionTitle: PropTypes.string,
  occurrenceSelectionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['weekly', 'monthly', 'amount']),
      name: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      options: PropTypes.array,
    }),
  ),
  isLoadingError: PropTypes.bool,
  onTryAgainPress: PropTypes.func,
  isTopUpSomeOne: PropTypes.bool,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      phone: PropTypes.string,
    }),
  ),
  onPhoneChanged: PropTypes.func,
  handleOnPressRecipient: PropTypes.func,
  recentContacts: PropTypes.array,
  phoneNumberValidation: PropTypes.func,
  isValidPhoneNumber: PropTypes.bool,
  setIsValidTopupNumber: PropTypes.func,
  onContactListIconPress: PropTypes.func,
  isContactList: PropTypes.bool,
  setPhoneNo: PropTypes.func,
  userType: PropTypes.oneOf(Object.values(User_Types)),
  hideSaveCardForLater: PropTypes.bool,
  selectedValue: PropTypes.object,
  onAddOffer: PropTypes.func,
  customTickLottie: PropTypes.object,
  selectedTab: PropTypes.number,
  onSelectTabChange: PropTypes.func,
  isCustomAmount: PropTypes.bool,
  withCustomTabAmount: PropTypes.bool,
  onChangeCustomAmount: PropTypes.func,
  customAmount: PropTypes.number,
  customAmountValidation: PropTypes.oneOf([
    CUSTOM_AMOUNT_VALIDATION_STATUS.MAX_ERROR,
    CUSTOM_AMOUNT_VALIDATION_STATUS.REGEX_ERROR,
    CUSTOM_AMOUNT_VALIDATION_STATUS.VALID,
  ]),
  customAmountMaximum: PropTypes.number,
  isCurrencyFirst: PropTypes.bool,
  onCodeChanged: PropTypes.func,
  onCameraPressed: PropTypes.func,
  tintColor: PropTypes.string,
  textColor: PropTypes.string,
  baseColor: PropTypes.string,
  selectionColor: PropTypes.string,
  helperTextColor: PropTypes.string,
  labelTextStyle: PropTypes.object,
  keyboardType: PropTypes.string,
  containerStyle: PropTypes.object,
  textInputContainerStyle: PropTypes.object,
  setIsValidVoucherTopupNumber: PropTypes.func,
  regexForInput: PropTypes.object,
  maxLength: PropTypes.number,
  isVoucherTopUp: PropTypes.bool,
  iconName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  voucherBtnContainerStyle: PropTypes.object,
  isVoucherTopUpContainer: PropTypes.bool,
  setVoucherTopupNumber: PropTypes.func,
  voucherTopupNumber: PropTypes.string,
  onQRRead: PropTypes.func,
  shouldScanVoucherCode: PropTypes.bool,
  qrCodeScannerProps: PropTypes.object,
  subtitleStyle: ViewPropTypes.style,
};

export default withTheme(PaymentBody);
